import { ac, roles } from "@apps/server/auth/permissions";
import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { env } from "~/env";

const _authClient = createAuthClient({
	baseURL: env.VITE_SERVER_URL,
	plugins: [
		// @ts-ignore: stupid better-auth not recognizing custom roles
		adminClient({ ac, roles }),
		// TODO: the role field is already inferred without this plugin but as string | null | undefined.
		// check if the logged in user always has it as string then enable this plugin
		// inferAdditionalFields({ user: { role: { type: "string" } } }),
	],
});

/** A react hook to check if the currently logged in user has the required permissions. It can return `null` if the session is pending.
 * Otherwise it will return a `boolean`.
 * It does not make any server-side call for validating the permissions, instead it gets the roles from active session in the client.
 */
// function usePermission(permissions: PermissionsToCheck, type: "any" | "all" = "any") {
// 	const [hasPermission, setHasPermission] = useState<boolean | null>(null);
// 	const session = _authClient.useSession();

// 	useEffect(() => {
// 		if (session.isPending) {
// 			setHasPermission(null);
// 			return;
// 		}

// 		const roleStr = session.data?.user.role;
// 		if (!roleStr) {
// 			setHasPermission(false);
// 			return;
// 		}

// 		const roles = roleStr.split(",");

// 		if (type === "any") {
// 			const _hasPermission = roles.some((role) =>
// 				_authClient.admin.checkRolePermission({ permissions, role: role as Role }),
// 			);
// 			setHasPermission(_hasPermission);
// 		} else {
// 			const _hasPermission = roles.every((role) =>
// 				_authClient.admin.checkRolePermission({ permissions, role: role as Role }),
// 			);
// 			setHasPermission(_hasPermission);
// 		}
// 	}, [session.isPending, session.data, permissions, type]);

// 	return hasPermission;
// }

/**
 * An async function to check if the currently logged in user has the required permissions. It will return a `boolean`.
 * This function is ideal for using in `loader()` or `beforeLoad()` functions.
 * It does not make any server-side call for validating the permissions, instead it gets the roles from active session in the client.
 */
// async function hasPermission(permissions: PermissionsToCheck, type: "any" | "all" = "any") {
// 	const session = await _authClient.getSession();
// 	if (!session.data?.user) return false;

// 	const roleStr = session.data.user.role;
// 	if (!roleStr) return false;

// 	const roles = roleStr.split(",");

// 	if (type === "any") {
// 		return roles.some((role) => _authClient.admin.checkRolePermission({ permissions, role: role as Role }));
// 	}

// 	return roles.every((role) => _authClient.admin.checkRolePermission({ permissions, role: role as Role }));
// }

/** auth client with additional utilities  */
export const authClient = Object.assign(_authClient, {
	custom: {
		// usePermission,
		// hasPermission,
	},
});
